<template>
    <div class="container">
        <!-- Student Invitees Table -->
        <b-form-group class="ml-4">
            <div v-if="Array.isArray(studentDatas) && studentDatas.length">
                <p class="font-weight-bold">Total Students: {{ studentDatas.length }}</p>
                <table class="table table-striped table-bordered">
                    <thead class="thead-dark">
                        <tr>
                            <th>
                                <input type="checkbox" v-model="selectAll" @change="toggleSelectAll" />
                            </th>
                            <th>Student Name</th>
                            <th>Admission No.</th>
                            <th>Email</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="inviteeData in studentDatas" :key="inviteeData.id">
                            <td>
                                <input type="checkbox" :value="inviteeData" v-model="selectedStudents" />
                            </td>
                            <td>
                                {{ inviteeData.name }}
                                <span v-if="listOfUsersEnrolled.some(user => user.email === inviteeData.invitee)"
                                    style="display: block; font-size: 0.7rem; font-style: italic; color: #17a2b8; margin-top: 2px;">
                                    Moved to Class
                                </span>
                            </td>
                            <td>{{ inviteeData.admission_no }}</td>
                            <td>{{ inviteeData.invitee }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Send Invitations Button -->
            <b-button v-if="studentDatas.length" variant="primary" class="font-weight-bolder text-white"
                :disabled="!selectedStudents.length || sendInvites.disabled" @click="sendInvitations">
                <b-spinner small v-if="sendInvites.disabled" class="mr-2" />
                {{ sendInvites.text }}
            </b-button>
        </b-form-group>

        <!-- Error Messages -->
        <b-form-group class="ml-4">
            <!-- Failed Invitations -->
            <span class="text-danger" v-if="failedinvitation">
                <template v-if="Array.isArray(failedinvitation)">
                    <div v-for="(email, i) in failedinvitation" :key="i">
                        Invitation already accepted by {{ email }}
                    </div>
                </template>
                <template v-else>
                    Invitation already accepted by {{ failedinvitation }}
                </template>
            </span>

            <!-- Validation Errors -->
            <span class="text-danger" v-if="responseErrors.invitee">
                {{ responseErrors.invitee[0] }}
            </span>
        </b-form-group>
    </div>
</template>
<script>
import axios from "axios";

export default {
    props: ["groupInfo"],

    data() {
        return {
            listOfUsersEnrolled: [],
            publicusers: [],
            studentDatas: [],
            selectedStudents: [],
            selectAll: false,
            responseErrors: {},
            failedinvitation: null,
            sendInvites: {
                text: "Invite & Move To Class",
                disabled: false,
            },
        };
    },

    async created() {
        await this.getEnrolledSubgroupUsers();
        await this.getPublicUsers();
    },

    watch: {
        selectedStudents(val) {
            this.selectAll = val.length === this.studentDatas.length;
        }
    },

    methods: {
        async getEnrolledSubgroupUsers() {
            let userList = this.$store.getters.getAPIKey.getEnrollSubgroupUsersList;
            let url = userList.replace("usersubgroup_id", this.groupInfo.id);
            await this.$axios.get(url).then((response) => {
                this.listOfUsersEnrolled = response.data.filter(
                    (students) => students.pivot.usersubgrouprole_id == 2
                );
            });
        },

        async getPublicUsers() {
            const url = `${this.$store.getters.getAPIKey.mainAPI}/admissionforms/usergroup-publicusers/${this.groupInfo.id}`;
            try {
                const response = await this.$axios.get(url);
                this.publicusers = response.data;
                this.updateTableFromInputData();
            } catch (error) {
                console.error("Error fetching public users:", error);
            }
        },

        toggleSelectAll() {
            if (this.selectAll) {
                this.selectedStudents = [...this.studentDatas];
            } else {
                this.selectedStudents = [];
            }
        },

        async sendInvitations() {
            this.sendInvites.text = "Sending...";
            this.sendInvites.disabled = true;

            const payload = {
                invite_to: "usersubgroup",
                invite_to_id: this.groupInfo.id,
                role_id: 2,
                invite_with_profiles: this.selectedStudents,
            };

            const url = this.$store.getters.getAPIKey.userInvitations;

            try {
                await axios.post(url, payload);
                this.selectedStudents = [];
                this.studentDatas = [];
                this.responseErrors = {};
                this.failedinvitation = null;
                this.sendInvites.text = "Invite & Move To Class";
                this.sendInvites.disabled = false;
                this.selectAll = false;

                this.$toast.success("Successfully Invited.", {
                    position: "top",
                    duration: 3000,
                });

                await this.getEnrolledSubgroupUsers();
                await this.getPublicUsers();
            } catch (error) {
                this.responseErrors = error.response?.data?.errors || {};
                this.failedinvitation = error.response?.data?.failed_invitee || null;
                this.sendInvites.text = "Invite & Move To Class";
                this.sendInvites.disabled = false;
            }
        },

        updateTableFromInputData() {
            this.studentDatas = this.publicusers.map((student) => ({
                id: student.id,
                name: student.name,
                invitee: student.email,
                roll_number: null,
                admission_no: student.admission_no,
            }));
        },
    },
};
</script>
  